import React from "react";
import nextId from "react-id-generator";
import "./deactivate.style.scss";
export default function Deactivate() {
  const [selectedQuestion, setSelectedQuestion] = React.useState("");

  const ExtraInfo = (obj) => {
    switch (obj.id) {
      case "temporary":
        return (
          <div className="extra-info-wrapper">
            <p style={{ marginBottom: 10 }}>
              Would you like to <span>log out</span> instead of deactivating
              your account?
            </p>
            <p>
              If you are deactivating your account, make sure that you still
              have access to the email address that you use to access AcadsHR.
              That way, you can easily reactivate your account by logging in{" "}
            </p>
          </div>
        );
        break;
      case "noJob":
        return (
          <div className="extra-info-wrapper">
            <p>
              No worries! We will help you find your desired job. Please contact
              us.
              <button>+91-9876543210</button>
            </p>
          </div>
        );
        break;

      default:
        break;
    }
  };
  return (
    <div className="deactivate-main">
      <section className="dm-section">
        <div className="dm-title">
          <h4>Are you sure you want to deactivate your account?</h4>
        </div>
        <div className="warning-line">
          <img src="https://img.icons8.com/ios/150/ff0000/info--v1.png" />
          <span>
            Once you deactivate, you will not be able to view or apply for any
            new jobs. Neither recruiters will be able to contact you.
          </span>
        </div>
        <div className="dm-questions">
          <ul>
            <h5>Can you tell us why you’re deactivating your account?</h5>
            {questions.map((obj) => (
              <li
                className={selectedQuestion === obj.id ? "selected-line" : ""}
                onClick={() =>
                  selectedQuestion == obj.id
                    ? setSelectedQuestion("")
                    : setSelectedQuestion(obj.id)
                }
              >
                <div className="line-wrapper">
                  <button>
                    <span />
                  </button>
                  <p>{obj.question}</p>
                </div>
                {selectedQuestion === obj.id ? ExtraInfo(obj) : ""}
              </li>
            ))}
          </ul>
        </div>
        <div className="feedback-section">
          <h6>Your feedback is important to us.</h6>
          <div className="fancy-input">
            <p>
              Feedback<span>{selectedQuestion === "other" ? "*" : ""}</span>
            </p>
            <textarea rows="5" />
          </div>
        </div>
      </section>
      <section className="dm-footer">
        <div className="dmf-left">
          <p>Enter your password to deactivate your account</p>
          <input placeholder="Enter Your Password" />
        </div>
        <div className="dmf-right">
          <button>Deactivate Now</button>
        </div>
      </section>
    </div>
  );
}
const questions = [
  {
    _id: nextId(),
    question: "This is temporary. I’ll be back.",
    id: "temporary",
  },
  { _id: nextId(), question: "I’m not finding suitable jobs", id: "noJob" },
  { _id: nextId(), question: "Other", id: "other" },
];
